

/* ── Fechas: siempre "AAAA-MM-DDTHH:MM" con ceros, respetando cambio de día/mes/año ── */
const pad2 = (n) => String(n).padStart(2, '0')
const aTexto = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`
const aFecha = (iso) => {
  const m = /^(\d{4})-(\d{1,2})-(\d{1,2})[T ](-?\d{1,2}):(\d{2})/.exec(String(iso || '').trim())
  return m ? new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) : new Date(String(iso))
}
export const normalizarFechaHora = (iso) => { const d = aFecha(iso); return isNaN(d) ? iso : aTexto(d) }
const moverMinutos = (iso, min) => { const d = aFecha(iso); return isNaN(d) ? iso : aTexto(new Date(d.getTime() + min * 60000)) }

/**
 * Función que solicita el registro de un nuevo evento a la colección de calendarIntent
 * @param {String} AppointmentType Recibe el identificador del recurso solicitado
 * @param {String} date Recibe la fecha inicial de la reservación
 * @param {String} platform Recibe la plataforma desde la cual se hizo la petición
 * @param {String} created Recibe la fecha en que se realiza la petición
 * @param {String} Building_Id Recibe el identificador de la unidad hospitalaria que solicita la reservación
 * @param {String} Resource_Id Recibe el identificador del quirófano que se desea reservar
 * @param {String} Resource_Name Recibe el nombre del quirófano que se desea reservar
 * @param {String} dateFinal Recibe la fecha final de la reservación
 * @returns String Devuelve el resultado de la solicitud
 */
export const createEventIntent = async (AppointmentType, date, platform, created, Building_Id,Resource_Id,
  Resource_Name,dateFinal,imagenologia,materialEspecial,rentaEquipos,muestrapatologica) => {

  // Se normalizan las fechas ANTES de registrar (evita "2026-10-3T01:30", "T-1:30",
  // "T24:00", día 32, etc.) y la higienización se calcula con aritmética de fechas:
  // 30 minutos antes del inicio y 30 minutos después del fin.
  date      = normalizarFechaHora(date)
  dateFinal = normalizarFechaHora(dateFinal)
  const timeStartPrueba   = moverMinutos(date, -30)
  const timeEndPrueba     = moverMinutos(dateFinal, 30)

  let eventObject = {
        AppointmentType:    AppointmentType,
        date:               date,
        platform:           platform,
        created:            created,
        Building_Id:        Building_Id,
        Resource_Id:        Resource_Id,
        Resource_Name:      Resource_Name,
        dateFinal:          dateFinal,
        dateLimpieza : timeStartPrueba,
        dateFinalLimpieza: timeEndPrueba,
        imagenologia : imagenologia,
        materialEspecial : materialEspecial,
        rentaEquipos : rentaEquipos,
        muestrapatologica : muestrapatologica
    }

    try {
      //https://us-central1-auto-factura-erps.cloudfunctions.net/createCalendarEvent
        const response = await fetch('https://agendaqx-createcalendarevent-1082492640140.us-south1.run.app', {
          method: 'POST',
          body: JSON.stringify(eventObject),
          headers: {
            'Content-Type': 'application/json',
          },
        });
        await response.json();
        return "success"
      } catch (error) {
        return error
      }
}

export const createReserveMail = async (correoColaborador,unidad,solicitud,nombreMedico,procedimiento,telefonoMedico,nombrePaciente,imagen,materiales,equipos,hemoderivados) => {
  try {
      //let sending = "https://apibot.hospitalesmac.app/public/surgeryroom/email/"+correoCalidad+"/"+nombre+"/<br>%20Fecha%20de%20solicitud:"+today+"<br>%20A%20continuación%20se%20presentan%20los%20datos%20del%20Nuevo%20Médico:%20<br>%20Nombre%20del%20médico:"+nombre+"<br>%20Unidad%20Hospitalaria:"+hospital+"<br>%20Cedula%20profesional%20de%20la%20especialidad:"+cedula+"<br>%20Telefono%20del%20médico:"+telefono+"<br>%20Correo%20electronico%20del%20médico:"+correoMedico+"/5fe72104fac6af0fa95dbbb0e910fde11"
      let sending = "https://apibot.hospitalesmac.app/public/surgeryroom/reserveemail/"+correoColaborador+"/"+unidad+"/<br>%20Fecha%20de%20solicitud:"+solicitud+"<br>%20A%20continuación%20se%20presentan%20los%20datos%20del%20Nuevo%20Agendamiento:%20<br>%20Nombre%20del%20médico:"+nombreMedico+"<br>%20Unidad%20Hospitalaria:"+unidad+"<br>%20Procedimiento:"+procedimiento+"<br>%20Telefono%20del%20médico:"+telefonoMedico+"<br>%20Nombre%20del%20paciente:"+nombrePaciente+"<br>"+imagen+"<br>"+materiales+"<br>"+equipos+"<br>"+hemoderivados+"<br>/" + process.env.REACT_APP_EMAIL_TOKEN
      fetch(sending)
          .then(function(response) {
              if(response.ok) {
              } else {
              }
            })
            .catch(function(error) {
            });
      return "success"
  } catch (error) {
      //console.log(error)
      return error
  }
}